import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loader from "components/Loader/index";

import GridWrapper from "custom-hooks/GridWrapper";
import { setApi } from "reducers/grid";

const TasksList = props => {
    const {
        updateApiGrid,
        itemId,
        itemType,
        onGridFloatingButtonClick,
        match: {
            params: { id: customerId },
        },
    } = props;
    const init = {
        limit: 50,
        key: "get_customer_accounts",
        extra: itemId ? `account_${itemType}_${itemId}.${customerId}` : `account_${customerId}`,
        customerId,
    };
    const gridKey = `${init.key}_${init.path || init.extra || ""}`;

    const [loadingState, setLoadingState] = useState(true);

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    const handleAccountCreate = () => {
        console.log("*** HANDLE ACCOUNT CREATE ***");
    };

    useEffect(() => {
        customerId && updateApiGrid({ customerId }, gridKey);
    }, [customerId]);

    return (
        <div className="content-wrapper with-fixed-status ordering-component-ui-core-wrapper">
            {loadingState && <Loader />}
            <GridWrapper
                tuner={() => init}
                initUpdate={false}
                onStart={onStart}
                onFinish={onFinish}
                onGridFloatingButtonClick={onGridFloatingButtonClick}
            />
        </div>
    );
};

export default connect(null, { updateApiGrid: setApi })(withRouter(TasksList));
